export const SECTION_TYPE = {
  IDENTIFICATION: 'identification',
  INPUT_FORM: 'inputform',
  MULTIMEDIA: 'multimedia',
  MEETING: 'meeting',
  INFO_SECTION: 'infoSection',
  GROUPED_FIELDS: 'groupedFields',
  DOWNLOAD_REPORTS: 'download',
  ESIGNATURE: 'esignature',
  TERMS_AND_CONDITIONS: 'termsAndConditions',
  TABLE: 'table',
};

export const USER_IDENTIFICATION_TYPE = {
  PAN: 'pan',
  AADHAAR: 'aadhaar',
};
export const API_STATUS = {
  SUCCESS: 'success',
  VALIDATION_ERROR: 'validationError',
  PENDING: 'pending',
  UNAUTHORIZED: 'unauthorized',
  SERVER_ERROR: 'serverError',
};

export const INPUT_TYPE = {
  TEXT: 'text',
  NUMBER: 'number',
  EMAIL: 'email',
  PHONE: 'phone',
  PAN: 'pan',
  AADHAAR: 'aadhaar',
  DATE: 'date',
  RADIO: 'radio',
  CHECKBOX: 'checkbox',
  DROPDOWN: 'dropdown',
  MULTIMEDIA: 'multimedia',
};

export const APPROVAL_STATE = {
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  PENDING_APPROVAL: 'PENDING_APPROVAL',
};
